// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"checkout_sectionHeading__TaysE","actionBtnContainer":"checkout_actionBtnContainer__1W54Q","nextBtn":"checkout_nextBtn__3vVtF"};